import React, { useState, useContext } from "react";

import {
  Modal,
  Backdrop,
  Fade,
  Button,
  makeStyles,
} from "@material-ui/core";

import { Snackbar } from "@material-ui/core";

import Plano from "./Plano";
import PlanForm from "./PlanForm";

import Edit from "../assets/Configuracoes/Icon material-edit@2x.png";
import addImg from "../assets/Configuracoes/Icon feather-plus@2x.png";
import X from "../assets/Configuracoes/X1.png";

import { PlanContext } from "../context/Plancontext";

export default function ModalPlano({ id, data }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [plan, setPlan] = useState({
    name: "",
    description: "",
    price: "",
    duration: "",
    features: "",
    isActive: true,
  });
  const [setPreview] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: "" });

  const { addPlan, editPlan } = useContext(PlanContext);

  const insere = async (e) => {
    e.preventDefault();
    if (!plan?.name) {
      alert("O campo nome é obrigatório.");
      return;
    }
    handleClose();
    const res = await addPlan(normalizePayload(plan));
    if (res === true) setSnack({ open: true, message: "Plano criado com sucesso" });
    else setSnack({ open: true, message: res?.error || "Erro ao criar plano" });
  };

  const edita = async (e) => {
    e.preventDefault();
    if (!plan?.name) {
      alert("O campo nome é obrigatório.");
      return;
    }
    handleClose();
    const res = await editPlan(id, normalizePayload(plan));
    if (res === true) setSnack({ open: true, message: "Plano atualizado" });
    else setSnack({ open: true, message: res?.error || "Erro ao atualizar plano" });
  };

  const handleOpen = () => {
    setOpen(true);

    if (id) {
      setPlan({
        name: data?.name || "",
        description: data?.description || "",
        price: data?.price || "",
        duration: data?.duration || "",
        features: data?.features || "",
        isActive: typeof data?.isActive === "boolean" ? data.isActive : true,
      });
      setPreview(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (!id) {
      setPlan({
        name: "",
        description: "",
        price: "",
        duration: "",
        features: "",
        isActive: true,
      });
      setPreview(false);
    }
  };

  const previewCard = (e) => {
    setPreview(true);
  };

  const normalizePayload = (p) => {
    const payload = {
      name: p.name?.trim(),
      description: p.description || undefined,
      duration: p.duration || undefined,
      features: p.features || undefined,
      isActive: typeof p.isActive === "boolean" ? p.isActive : true,
    };
    if (p.price !== undefined && p.price !== null && `${p.price}`.trim() !== "") {
      const num = Number(p.price);
      payload.price = isNaN(num) ? `${p.price}` : num;
    }
    return payload;
  };

  return (
    <div>
      {id === undefined ? (
        <Button onClick={(e) => { e.stopPropagation(); handleOpen(); }}>
          <img src={addImg} alt="addImg" className={classes.editbuttom} />
        </Button>
      ) : (
        <Button onClick={handleOpen}>
          <img src={Edit} alt="Edit" className={classes.editbuttom} />
        </Button>
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} onClick={(e) => e.stopPropagation()}>
            <div className={classes.close}>
              <Button onClick={handleClose}>
                <img src={X} alt="close" className={classes.closeButton} />
              </Button>
            </div>
            <div className={classes.plano}>
              <Plano data={plan} />
            </div>
            <PlanForm
              value={plan}
              onChange={setPlan}
              onPreview={previewCard}
              onSubmit={id ? edita : insere}
              submitting={false}
            />
          </div>
        </Fade>
      </Modal>
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ open: false, message: '' })}
        message={snack.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  modal: {
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    overflow: "scroll",
    display: "block",
  },
  plano: {
    marginTop: "10px",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  paper: {
    backgroundColor: theme.colors.white,
    padding: "10px",
    paddingTop: "0px",
    boxShadow: "0px 4px 16px #00000030",
    flexDirection: "column",
    display: "flex",
  },
  close: {
    width: "100%",
    justifyContent: "flex-end",
    display: "flex",
  },
  closeButton: {
    height: "23px",
  },
  addbuttom: {
    height: "21px",
    width: "21px",
  },
  formulario: {
    flex: 1,
    marginTop: "10px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
  },
  input: {},
  botao: {
    marginTop: "10px",
    width: "120px",
    height: "46px",
    font: "Karla,Regular",
    fontSize: "18px",
  },
  botoesEditores: {
    flexDirection: "row",
    alignSelf: "flex-start",
    display: "flex",
  },
  editor: {
    width: "50%",
  },
  editbuttom: {
    height: "24px",
  },
}));
